import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useDispatch, useSelector } from 'react-redux'

import { selectCurrentHotelName } from '../../accessors/index'
import { getInsights } from '../../actions/insights'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles/index'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import DirectBookings from './DirectBookings/index'
import styles from './Insights.module.scss'
import OTA from './OTA/index'
import ReclaimedGuests from './ReclaimedGuests/index'
import RepeatGuests from './RepeatGuests/index'
import ReservationLength from './ReservationLength/index'

const Insights = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getInsights())
  }, [dispatch])

  const loading = useSelector(s => s.insights.loading)
  const erred = useSelector(s => s.insights.erred)
  const currentHotelName = useSelector(selectCurrentHotelName)

  const invitePerformances = useSelector(s => s.insights.invitePerformances)

  const [reclaimedGuestsRef, reclaimedGuestsInView] = useInView({
    threshold: 1
  })

  const [otaBookingsRef, otaBookingsInView] = useInView({
    threshold: 1
  })

  const [repeatGuestsRef, repeatGuestsInView] = useInView({
    threshold: 1
  })

  const [reservationLengthRef, reservationLengthInView] = useInView({
    threshold: 1
  })

  if (loading) {
    return <LoadingIndicator longWaitingTreshold={120} />
  }

  if (erred) {
    return <div>Data is not ready yet, please try again later.</div>
  }

  return (
    <div className={styles.wrapper}>
      <CustomHeader
        isFixed
        title="Insights"
        subtitle={`for ${currentHotelName}`}
        width={1000}
      />
      <div className={styles.tabHolder}>
        {invitePerformances && (
          <a
            href="#reclaimedGuests"
            className={reclaimedGuestsInView ? styles.activeLink : ''}
          >
            Reclaimed guests
          </a>
        )}

        <a
          href="#otaBookings"
          className={otaBookingsInView && !repeatGuestsInView ? styles.activeLink : ''}
        >
          OTA bookings
        </a>
        <a
          href="#repeatGuests"
          className={
            repeatGuestsInView && !reservationLengthInView ? styles.activeLink : ''
          }
        >
          Repeat guests
        </a>
        <a
          href="#reservationLength"
          className={reservationLengthInView ? styles.activeLink : ''}
        >
          Reservation length
        </a>
      </div>
      <section ref={reclaimedGuestsRef} className={styles.section}>
        <div className={styles.scrollTarget} id="reclaimedGuests"></div>
        <ReclaimedGuests />
      </section>
      <section className={styles.section} ref={otaBookingsRef}>
        <div className={styles.scrollTarget} id="otaBookings"></div>
        <OTA />
        <DirectBookings />
      </section>
      <section ref={repeatGuestsRef} className={styles.section}>
        <div className={styles.scrollTarget} id="repeatGuests"></div>
        <RepeatGuests />
      </section>
      <section ref={reservationLengthRef} className={styles.section}>
        <div className={styles.scrollTarget} id="reservationLength"></div>
        <ReservationLength />
      </section>
    </div>
  )
}

export default Insights
